<div class="mat-table-container">
    <table mat-table [dataSource]="dataSource" style="width:100%">

        <ng-container matColumnDef="{{column.attributeName}}" *ngFor="let column of columns">
            <th mat-header-cell *matHeaderCellDef>
                {{ column.displayName }}
            </th>
            <td mat-cell *matCellDef="let element">
                <span *ngIf="column.type === 'date'">
                    {{ element[column.attributeName] | date: 'dd/MM/yyyy' }}
                </span>
                <span *ngIf="column.type === 'datetime'">
                    {{ element[column.attributeName] | date: 'dd/MM/yyyy HH:mm' }}
                </span>
                <span *ngIf="column.type === 'currency'">
                    ${{ element[column.attributeName] | number: '1.0-0' }}
                </span>
                <span *ngIf="column.type === 'text' || !column.type">
                    {{ element[column.attributeName] }}
                </span>
            </td>
        </ng-container>

        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>
                Acciones
            </th>
            
            <td mat-cell *matCellDef="let element" class="td-actions">
                
                <div class="d-flex actions-container">
                    <button mat-mini-fab color="primary" 
                        *ngIf="showEditButton"
                        class="tertiary-color shadow-none no-print" 
                        aria-label="Boton editar"
                        (click)="onEdit(element)">
                        <mat-icon>edit</mat-icon>
                    </button>

                    <button mat-mini-fab color="primary" 
                        *ngIf="showDeleteButton"
                        class="error-color shadow-none no-print" 
                        aria-label="Boton borrar"
                        (click)="onDelete(element)"
                    >
                        <mat-icon>delete</mat-icon>
                    </button>
                    
                    <button class="custom-button-secondary" 
                        mat-flat-button  
                        *ngIf="customAction"
                        (click)="onExecuteCustomAction(element)" >
                        {{  customAction }}
                    </button>
                </div>

            </td>
        </ng-container>

        <ng-container matColumnDef="progress">
            <th mat-cell *matCellDef="let element"></th>
            <td mat-header-cell *matHeaderCellDef [attr.colspan]="displayedColumns.length">
                <mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>
            </td>
        </ng-container>

        <tr class="mat-mdc-row" *matNoDataRow [hidden]="isLoading">
            <td class="mat-mdc-cell text-center font-weight-500" [attr.colspan]="displayedColumns.length">
                No hay datos disponibles
            </td>
        </tr>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-header-row *matHeaderRowDef="['progress']; sticky: true" class="progress-row"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
</div>

<mat-paginator
    class="mt-3"
    [length]="total"
    [pageSize]="pageSize"
    [pageSizeOptions]="[5, 10, 25, 100]"
    aria-label="Select page"
    showFirstLastButtons="true"
></mat-paginator>